import type { WordToken } from "../types";

const WORD_PATTERN = /[\p{L}\p{M}]+(?:['’\-][\p{L}\p{M}]+)*/gu;

export function sentenceAt(text: string, index: number): string {
  const sentenceStart = Math.max(
    text.lastIndexOf(".", index - 1),
    text.lastIndexOf("!", index - 1),
    text.lastIndexOf("?", index - 1),
    text.lastIndexOf("\n", index - 1),
  );

  const candidates = [
    text.indexOf(".", index),
    text.indexOf("!", index),
    text.indexOf("?", index),
    text.indexOf("\n", index),
  ].filter((value) => value >= 0);

  const sentenceEnd = candidates.length > 0 ? Math.min(...candidates) + 1 : text.length;
  return text.slice(sentenceStart + 1, sentenceEnd).replace(/\s+/g, " ").trim().slice(0, 800);
}

export function tokenizePage(text: string): WordToken[] {
  const tokens: WordToken[] = [];
  let lastIndex = 0;
  let ordinal = 0;

  for (const match of text.matchAll(WORD_PATTERN)) {
    const index = match.index ?? 0;
    if (index > lastIndex) {
      tokens.push({
        text: text.slice(lastIndex, index),
        isWord: false,
        context: "",
        key: `space-${ordinal++}`,
      });
    }

    tokens.push({
      text: match[0],
      isWord: true,
      context: sentenceAt(text, index),
      key: `word-${ordinal++}-${index}`,
    });
    lastIndex = index + match[0].length;
  }

  if (lastIndex < text.length) {
    tokens.push({
      text: text.slice(lastIndex),
      isWord: false,
      context: "",
      key: `space-${ordinal}`,
    });
  }

  return tokens;
}

export function normalizeWordId(word: string, targetLanguage: string): string {
  const normalizeForId = (value: string) =>
    value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ı/g, "i")
    .toLocaleLowerCase("en-US")
    .replace(/[^\p{L}\p{N}]+/gu, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);

  return `${normalizeForId(word) || "word"}-${normalizeForId(targetLanguage) || "language"}`;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function safeFileId(): string {
  return `${Date.now()}-${crypto.randomUUID()}.pdf`;
}
